module.exports = __webpack_public_path__ + "img/Background1.e2a7cabb.jpg";